<div class="nav-mobile">
    <div class="nav-mobile__logo">
        <img [src]="'../../../assets/img/' + headerImage" (click)="clickHeaderImage()"
             alt="Header logo"
             [class.pointer-events-none]="isOciUser">
    </div>
    <div *ngIf="isAuthorized">
        <button mat-button [matMenuTriggerFor]="profileMenu" class="button__icon" [addIntercomDataAttribute]="{key: 'nav-profile-btn', isMobile: true, isDesktop: false}">
            <i class="icon icon__extra-large icon-person"></i>
        </button>
        <mat-menu #profileMenu="matMenu">
            <button mat-menu-item
                    [addIntercomDataAttribute]="{key: 'nav-go-to-profile-btn', isMobile: true, isDesktop: false}"
                    data-ga-value="nav-mobile-profile"
                    *checkViewAsOciUser="false"
                    (click)="navigateTo(['/profile'])"
                    [myRouterLinkActive]="'/profile'">
                {{ 'LABELS.MY_PROFILE' | translate }}
            </button>
            <button mat-menu-item
                    data-ga-value="nav-mobile-privacy-conditions"
                    [matMenuTriggerFor]="privacyMenu" (menuOpened)="getPolicyLinks()">
                {{ 'LABELS.PRIVACY_AND_CONDITIONS' | translate }}
            </button>
            <button mat-menu-item
                    data-ga-value="nav-mobile-logout"
                    (click)="logout.emit()">{{ 'LABELS.LOGOUT' | translate }}</button>
        </mat-menu>
    </div>
    <div *ngIf="!isAuthorized">
        <button mat-button [matMenuTriggerFor]="privacyMenu" (menuOpened)="getPolicyLinks()">
            {{ 'LABELS.PRIVACY_AND_CONDITIONS' | translate }}
        </button>
    </div>
    <mat-menu #privacyMenu="matMenu">
        <button mat-menu-item class="nav-mobile__privacy-link" *ngIf="termsAndConditionsLink">
            <a [href]="termsAndConditionsLink" target="_blank">{{ 'LABELS.TERMS_AND_CONDITIONS' | translate }}</a>
        </button>
        <button mat-menu-item class="nav-mobile__privacy-link" *ngIf="privacyPolicyLink">
            <a [href]="privacyPolicyLink" target="_blank">{{ 'LABELS.PRIVACY_POLICY' | translate }}</a>
        </button>
        <button mat-menu-item class="nav-mobile__privacy-link" *ngIf="cookiePolicyLink">
            <a [href]="cookiePolicyLink" target="_blank">{{ 'LABELS.COOKIE_POLICY' | translate }}</a>
        </button>
        <button mat-menu-item
                aria-label="Open cookie settings"
                (click)="openCookieSettings()">
            {{ 'LABELS.COOKIE_SETTINGS' | translate }}
        </button>
    </mat-menu>
</div>
